module.exports = __webpack_public_path__ + "img/home-section.e22f8aa0.jpg";